export const AccordionImagesComponent = ({
  accordionOpen,
  className = "",
}: {
  accordionOpen: number;
  className?: string;
}) => {
  return (
    <div
      className={`
      flex
      w-full md:h-[600px] width-lim:h-[800px]
      items-center justify-center
      ${
        accordionOpen === 1 &&
        "bg-[url('assets/images/accordion1.png')] bg-[length:430px]"
      }
      ${accordionOpen === 2 && "bg-[url('assets/images/accordion2.png')]"}
      ${accordionOpen === 3 && "bg-[url('assets/images/accordion3.png')]"}
      ${accordionOpen === 4 && "bg-[url('assets/images/accordion4.png')]"}
      ${accordionOpen === 5 && "bg-[url('assets/images/accordion5.png')]"}
      bg-contain bg-no-repeat bg-center
      transition-all duration-500
      ${className}
      `}
    />
  );
};
